export const DEPLOYMENT_PROFILE = (
  import.meta.env.VITE_DEPLOYMENT_PROFILE || 'dhruv'
).toLowerCase();

/** Dhruv dedicated workspace deployment (canonical profile: dhruv). */
export const isDhruvDeployment = () =>
  DEPLOYMENT_PROFILE === 'dhruv' || DEPLOYMENT_PROFILE === 'dhruv_parivartan';

/** @deprecated Use isDhruvDeployment — compatibility alias */
export const isParivartanDeployment = isDhruvDeployment;

export { COMPANY_SHORT_NAME as PLATFORM_DISPLAY_NAME } from './branding';
